import React, { useContext, useEffect, useState } from 'react'
import { MdClose } from 'react-icons/md'
import 'react-responsive-modal/styles.css'
import { ThemeContext } from 'styled-components'

import * as S from './styles'

interface Props {
  isOpen: boolean
  isLoading: boolean
  handleClose(): void
  handleConfirm(password?: string): Promise<void>
}

const CancelOrderModal: React.FC<Props> = ({
  isOpen,
  isLoading,
  handleClose,
  handleConfirm
}) => {
  const themeContext = useContext(ThemeContext)

  const [password, setPassword] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    if (isOpen) {
      setPassword('')
      setError('')
    }
  }, [isOpen])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    if (isLoading) return

    if (!password.trim()) {
      setError('Informe a senha de cancelamento!')
      return
    }

    try {
      setError('')

      await handleConfirm(password)
    } catch (err) {
      setError(
        err?.data?.message ??
          'Não foi possível cancelar o pedido. Tente novamente!'
      )
    }
  }

  return (
    <S.Container
      open={isOpen}
      showCloseIcon={false}
      onClose={handleClose}
      center
      styles={{
        modal: {
          padding: '2rem',
          background: themeContext.colors.primary,
          borderRadius: '1.5rem'
        }
      }}
    >
      <S.Content>
        <S.Header>
          <S.Title>Cancelar pedido</S.Title>

          <div className="right">
            <button type="button" title="Fechar" onClick={handleClose}>
              <MdClose />
            </button>
          </div>
        </S.Header>

        <S.Form onSubmit={handleSubmit}>
          <S.Description>
            Esta loja exige uma senha para cancelar pedidos. Informe a senha de
            cancelamento para confirmar.
          </S.Description>

          <S.Col>
            <S.Label htmlFor="cancelOrderPassword">
              Senha de cancelamento
            </S.Label>

            <S.Input
              id="cancelOrderPassword"
              name="cancelOrderPassword"
              type="password"
              autoComplete="off"
              placeholder="Digite a senha de cancelamento"
              className={error ? 'is-invalid' : ''}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={isLoading}
            />

            {!!error && <S.Error>{error}</S.Error>}
          </S.Col>

          <S.Buttons>
            <button type="button" onClick={handleClose} disabled={isLoading}>
              Voltar
            </button>

            <button type="submit" className="red" disabled={isLoading}>
              {isLoading ? 'Cancelando...' : 'Confirmar cancelamento'}
            </button>
          </S.Buttons>
        </S.Form>
      </S.Content>
    </S.Container>
  )
}

export default CancelOrderModal
